export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_PREPARE = 'LOGOUT_PREPARE';
export const LOGOUT_USER = 'LOGOUT_USER';
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const AUTH_RE_CHECK = 'AUTH_RE_CHECK';
export const AUTH_NEEDS_RELOG = 'AUTH_NEEDS_RELOG';
export const SHOW_SYSTEM_MESSAGE = 'SHOW_SYSTEM_MESSAGE';
export const DISMISS_SYSTEM_MESSAGE = 'DISMISS_SYSTEM_MESSAGE';
export const SHOW_TEXT_OVERLAY = 'SHOW_TEXT_OVERLAY';
export const DISMISS_TEXT_OVERLAY = 'DISMISS_TEXT_OVERLAY';
export const SHOW_SERIALHELP_OVERLAY = 'SHOW_SERIALHELP_OVERLAY';
export const DISMISS_SERIALHELP_OVERLAY = 'DISMISS_SERIALHELP_OVERLAY';
export const SHOW_SECTION_INCOMPLETE = 'SHOW_SECTION_INCOMPLETE';
export const DISMISS_SECTION_INCOMPLETE = 'DISMISS_SECTION_INCOMPLETE';
export const STATUS_PROJECT = 'STATUS_PROJECT';
export const STATUS_BUNDLE = 'STATUS_BUNDLE';
export const STATUS_OPTION = 'STATUS_OPTION';
export const STATUS_PAYMENT = 'STATUS_PAYMENT';
export const STATUS_ORDER = 'STATUS_ORDER';
export const STATUS_CHECKOUT = 'STATUS_CHECKOUT';
export const STATUS_CHECKOUT_DEP = 'STATUS_CHECKOUT_DEP';
export const STATUS_SUBMIT = 'STATUS_SUBMIT';
export const STATUS_RESET = 'STATUS_RESET';
export const STATUS_SERIAL = 'STATUS_SERIAL';
export const STATUS_UPLOAD = 'STATUS_UPLOAD';
export const STATUS_PRIVACY = 'STATUS_PRIVACY';
export const STATUS_TEACHER = 'STATUS_TEACHER';
export const STATUS_TEACHER_PDF = 'STATUS_TEACHER_PDF';
export const STATUS_PAYEVER_CHANGE_PDF = 'STATUS_PAYEVER_CHANGE_PDF';
export const STATUS_SEPA = 'STATUS_SEPA';
export const STATUS_FINISH = 'STATUS_FINISH';
export const SHOW_NEXT_BUTTON = 'SHOW_NEXT_BUTTON';
export const HIDE_NEXT_BUTTON = 'HIDE_NEXT_BUTTON';
export const CONTENT_CHANGE = 'CONTENT_CHANGE';
export const SET_CUSTOMER_FORM = 'SET_CUSTOMER_FORM';
export const RESET_CUSTOMER_FORM = 'RESET_CUSTOMER_FORM';
export const SET_UPLOAD = 'SET_UPLOAD';
export const RESET_UPLOAD = 'RESET_UPLOAD';
export const FAILED_UPLOAD = 'FAILED_UPLOAD';
export const BEGIN_UPLOAD = 'BEGIN_UPLOAD';
export const SET_PAYEVER = 'SET_PAYEVER';
export const SET_PENDING_ORDER = 'SET_PENDING_ORDER';
export const RESET_PAYEVER = 'RESET_PAYEVER';
export const FAILED_PAYEVER = 'FAILED_PAYEVER';
export const SUCCESS_PAYEVER = 'SUCCESS_PAYEVER';
export const PENDING_PAYEVER = 'PENDING_PAYEVER';
export const CANCEL_PAYEVER = 'CANCEL_PAYEVER';
export const CHECK_PAYEVER = 'CHECK_PAYEVER';
export const UNCHECK_PAYEVER = 'UNCHECK_PAYEVER';
export const RESTART_PAYEVER = 'RESTART_PAYEVER';
export const CHECKOUT_PAYEVER = 'CHECKOUT_PAYEVER';
export const UNKNOWN_ERROR_PAYEVER = 'UNKNOWN_ERROR_PAYEVER';


// WEBPACK FOOTER //
// ./src/constants/index.js